module.exports = __webpack_public_path__ + "media/src/images/site-top/icon-ishikawa-md-1d69374424c99e592f92c019076137d6.png";